import { useCart } from '@chordcommerce/react-autonomy';
import { useState, useEffect } from 'react';
import { useShippingRates } from '../graphql/queries/use-shipping-rates';
import formatMoney from '~/utils/format-money';

export const useCalculateShipping = () => {
  const { cart } = useCart();
  const shippingRates = useShippingRates();
  const [shippingAmount, setShippingAmount] = useState<number>(0);

  useEffect(() => {
    const calculateShipping = () => {
      if (cart.totalQuantity === 0 || !cart.lineItems) return 0;
      const totalWeight: number = cart.lineItems.reduce((acc, item) => {
        const weight = item.variant?.weight ?? 0;
        return acc + Number(weight) * item.quantity;
      }, 0);
      const shippingRate = shippingRates.find((rate) => {
        if (rate.maxWeight === null) {
          return totalWeight >= rate.minWeight;
        }
        return totalWeight <= rate.maxWeight && totalWeight >= rate.minWeight;
      });
      return shippingRate?.amount || 0;
    };
    setShippingAmount(calculateShipping());
  }, [cart.lineItems, cart.totalQuantity, shippingRates]);
  const displayShippingAmount =
    shippingAmount === 0
      ? '-'
      : `${formatMoney(shippingAmount, { locale: 'en', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return { shippingAmount, displayShippingAmount };
};
